'use strict';

module.exports = function SubteamApi(authentication, goldApi, s3Api) {
	if (!authentication || !goldApi || !s3Api) {
		throw new Error('invalid-args');
	}
	const self = this,
		getLicense = async () => {
			const license = await authentication.authenticationModel.getLicense();
			if (license) {
				return license;
			}
			throw 'not-authenticated';
		},
		getLicenseAndAffiliateTeamIdentity = async () => {
			const license = await getLicense(),
				affiliateTeamIdentity = await authentication.affiliateTeamIdentityProvider.getAffiliateTeamIdentity(),
				ids = {license, affiliateTeamIdentity};
			return ids;
		};

	self.acceptInvitation = (teamId, inviteId) => {
		if (!teamId || !inviteId) {
			return Promise.reject(new Error('invalid-args'));
		}

		return getLicense()
		.then(license => goldApi.exec('subteam/invite/accept', {license: license, inviteId: inviteId, teamId: teamId}));
	};

	self.changeMemberRole = (teamId, memberAccount, role) => {
		if (!teamId || !memberAccount || !role) {
			return Promise.reject(new Error('invalid-args'));
		}
		return getLicense()
		.then(license => goldApi.exec('subteam/member/change_role', {license: license, teamId: teamId, memberAccount: memberAccount, role: role}));
	};

	self.create = (teamName) => {
		if (!teamName || !teamName.trim()) {
			return Promise.reject(new Error('invalid-args'));
		}
		return getLicense()
		.then(license => goldApi.exec('subteam/create', {license: license, teamName: teamName}));
	};

	self.delete = (teamId) => {
		if (!teamId) {
			return Promise.reject(new Error('invalid-args'));
		}
		return getLicense()
		.then(license => goldApi.exec('subteam/delete', {license: license, teamId: teamId}));
	};

	self.invite = (inviteEmail, teamId, role) => {
		if (!inviteEmail || !teamId || !role) {
			return Promise.reject(new Error('invalid-args'));
		}
		return getLicense()
		.then(license => goldApi.exec('subteam/invite/new', {license: license, inviteEmail: inviteEmail, teamId: teamId, role: role}));
	};

	self.listInvitations = (teamId) => {
		if (!teamId) {
			return Promise.reject(new Error('invalid-args'));
		}
		return getLicense()
		.then(license => goldApi.exec('subteam/invite/list', {license: license, teamId: teamId}));
	};

	self.listTeams = async () => {
		const ids = await getLicenseAndAffiliateTeamIdentity();
		return goldApi.exec('subteam/list', ids);
	};

	self.removeMember = (teamId, memberAccount) => {
		if (!teamId || !memberAccount) {
			return Promise.reject(new Error('invalid-args'));
		}
		return getLicense()
		.then(license => goldApi.exec('subteam/member/remove', {license: license, memberAccount: memberAccount, teamId: teamId}));
	};
	self.listAllowedMembers = (teamId) => {
		if (!teamId) {
			return Promise.reject(new Error('invalid-args'));
		}
		return getLicense()
		.then(license => goldApi.exec('subteam/allowed_members_list_url', {license: license, teamId: teamId}))
		.then(listUrl => s3Api.loadUrl(listUrl))
		.then(xmlDocument => {
			return Array.from(xmlDocument.querySelectorAll('Key')).map(key => key.textContent.split('/')[2]).map(file => file.slice(0, file.length - 5));
		});
	};
};
